


export const camelToDash = (name) => {
    // matches all uppercased letters and replace them with their lowercased versions preceded by "-".
    return name.replace(/[A-Z]/g, m => "-" + m.toLowerCase());
}